import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  faFacebook,
  faWhatsapp,
  faLinkedin,
  faInstagram,
  faTiktok,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { faAddressBook, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FetchDataService } from 'src/app/shared/services/fetch-data.service';
import { environment } from 'src/environments/environment';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { successDialog } from 'src/app/shared/dialog';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css'],
})
export class ContactFormComponent {
  buttonTextForForm = 'Send';
  contactForm: FormGroup;
  icons: { [key: string]: IconProp } = {
    faFacebook: faFacebook,
    faWhatsapp: faWhatsapp,
    faLinkedin: faLinkedin,
    faEnvelope: faEnvelope,
    faInstagram: faInstagram,

    faYoutube: faYoutube,
    faTiktok: faTiktok,
    faAddressBook: faAddressBook,
  };
  soicalMediaLinks: any = [];
  whatsappLink: string = '';
  whatsappNumber: string = '';
  emailpath: string = '';
  locations!: string;
  emails!: string;
  sheetUrl!: string;
  contactImage =
    '../../../../../assets/' +
    environment.projectName +
    '/media/contactusComponents/contact.png';
  whatAppPath =
    '../../../assets/' + environment.projectName + '/icons/whatsapp-logo.png';
  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private fetchDataService: FetchDataService,
    private translate: TranslateService
  ) {
    this.contactForm = this.fb.group({
      fullName: ['', [Validators.required, Validators.pattern('[a-zA-Z ]*')]],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: [
        '',
        [
          Validators.required,
          Validators.pattern('[0-9]+'),
          Validators.minLength(10),
          Validators.maxLength(13),
        ],
      ],
      message: ['', [Validators.required, Validators.minLength(5)]],
    });
  }
  ngOnInit() {
    this.fetchDataService.getSocialLinkes().subscribe({
      next: (data: any) => {
        this.soicalMediaLinks = data.soicalMediaLinks;
        this.locations = data.location;
        this.emails = data.email;
        this.sheetUrl = data.sheetUrl;
        this.whatsappLink = data.soicalMediaLinks.find(
          (item: any) => item.name === 'whatsapp'
        ).link;
        this.whatsappNumber = data.soicalMediaLinks
          .find((item: any) => item.name === 'whatsapp')
          .link.split('wa.me/')[1];

        this.emailpath = data.soicalMediaLinks
          .find((item: any) => item.name === 'email')
          .link.split('mailto:')[1];
      },
      error: (err) => {
        console.error('Error fetching services:', err);
      },
    });
  }
  // Getter methods for form controls
  get fullName() {
    return this.contactForm.get('fullName');
  }

  get email() {
    return this.contactForm.get('email');
  }

  get phoneNumber() {
    return this.contactForm.get('phoneNumber');
  }

  get message() {
    return this.contactForm.get('message');
  }

  onSubmit() {
    if (this.contactForm.valid && this.sheetUrl) {
      this.submitForm(this.contactForm.value).subscribe(
        (response) => {
          this.contactForm.reset();
          this.translate
            .get('Thank You, We Will Contact You Soon')
            .subscribe((msg: string) => {
              successDialog(msg);
            });
        },
        (error) => {
          console.error('Error saving data', error);
        }
      );
    } else {
      this.contactForm.markAllAsTouched();
      console.log('Form is not valid');
    }
  }

  submitForm(data: any) {
    return this.http.post(this.sheetUrl, data);
  }
}
